import axiosInstance from '../components/utils/axios/axiosInstance';
import {
  FETCH_CARS_FINISHED,
  ADD_CAR_SUCCESSED,
  SET_CAR_ACTIVE_FLAG_DONE,
  UPDATE_CAR_USER_PRIMARY_DONE
  // eslint-disable-next-line import/named
} from './constantsActions';

export function fetchCarsFinished(cars) {
  return {
    type: FETCH_CARS_FINISHED,
    payload: cars
  };
}

export function addCarSuccessed(car) {
  return {
    type: ADD_CAR_SUCCESSED,
    payload: car
  };
}

export function setCarActiveFlagDone(carId, active) {
  return {
    type: SET_CAR_ACTIVE_FLAG_DONE,
    payload: { carId, active }
  };
}

export function updateCarUserPrimaryDone(carId) {
  return {
    type: UPDATE_CAR_USER_PRIMARY_DONE,
    payload: carId
  };
}

export function fetchCars() {
  return async (dispatch, getState) => {
    const { id } = getState().auth;
    const { data } = await axiosInstance.get(`/api/car/findCarsByUserId`, {
      params: {
        userId: id
      }
    });

    dispatch(fetchCarsFinished(data));
  };
}

export function addCar(car) {
  return async (dispatch, getState) => {
    const { id } = getState().auth;
    const { data } = await axiosInstance.post(`/api/car/saveUserCar`, {
      active: true,
      brand: car.name,
      owner: true,
      plateNo: car.plateNo,
      primary: car.primary,
      userId: id
    });
    dispatch(addCarSuccessed(data));
  };
}

export function setCarActiveFlag(carId, active) {
  return async (dispatch, getState) => {
    const { id } = getState().auth;
    await axiosInstance.post(
      `/api/car/setCarActiveFlag`,
      {},
      {
        params: {
          carId,
          active,
          userId: id
        }
      }
    );
    dispatch(setCarActiveFlagDone(carId, active));
  };
}

export function updateCarUserPrimary(carId) {
  return async (dispatch, getState) => {
    const { id } = getState().auth;
    await axiosInstance.post(
      `/api/car/updateCarUserPrimary`,
      {},
      {
        params: {
          carId,
          userId: id
        }
      }
    );
    dispatch(updateCarUserPrimaryDone(carId));
  };
}

export function shareCar(data) {
  return async (dispatch, getState) => {
    const { id } = getState().auth;
    const {data: resData} = await axiosInstance.post(
      `/api/car/shareCar`,
      {
        carId: data.car,
        dateFrom: data.dateFrom,
        dateTo: data.dateTo,
        ownerUserId: id,
        userId: data.userTo
      }
    );
    
    return resData
  }
}

export function fetchCar() {
  return () => {};
}
